// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file api/v1/api.proto (package api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/api.proto.
 */
export const file_api_v1_api: GenFile = /*@__PURE__*/
  fileDesc("ChBhcGkvdjEvYXBpLnByb3RvEgZhcGkudjEiPwoXTGlzdENhY2hlRW50cmllc1JlcXVlc3QSFAoMb3JnYW5pemF0aW9uGAEgASgJEg4KBnByZWZpeBgCIAEoCSI/ChhMaXN0Q2FjaGVFbnRyaWVzUmVzcG9uc2USIwoHZW50cmllcxgBIAMoCzISLmFwaS52MS5DYWNoZUVudHJ5InYKCkNhY2hlRW50cnkSCwoDa2V5GAEgASgJEhQKDGlzX2RpcmVjdG9yeRgCIAEoCBISCgpzaXplX2J5dGVzGAMgASgDEjEKDWxhc3RfbW9kaWZpZWQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIj8KGURlbGV0ZUNhY2hlRW50cmllc1JlcXVlc3QSFAoMb3JnYW5pemF0aW9uGAEgASgJEgwKBGtleXMYAiADKAkiHAoaRGVsZXRlQ2FjaGVFbnRyaWVzUmVzcG9uc2UiUQoPSW5zaWdodHNSZXF1ZXN0EhQKDG9yZ2FuaXphdGlvbhgBIAEoCRIoCgtncmFudWxhcml0eRgCIAEoDjITLmFwaS52MS5HcmFudWxhcml0eSL2BgoQSW5zaWdodHNSZXNwb25zZRIVCg1ydW5uZXJzX2NvdW50GAEgASgDEjYKCmFnZ3JlZ2F0ZXMYAiADKAsyIi5hcGkudjEuSW5zaWdodHNSZXNwb25zZS5BZ2dyZWdhdGUafQoJQWdncmVnYXRlEiwKCHN0YXJ0X2F0GAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBJCChBwbGF0Zm9ybV9tZXRyaWNzGAIgAygLMiguYXBpLnYxLkluc2lnaHRzUmVzcG9uc2UuUGxhdGZvcm1NZXRyaWNzGo8ECg9QbGF0Zm9ybU1ldHJpY3MSIgoIcGxhdGZvcm0YASABKA4yEC5hcGkudjEuUGxhdGZvcm0SZgoYaW1hZ2VfZGlzdHJpYnV0aW9uX2NvdW50GAIgAygLMkQuYXBpLnYxLkluc2lnaHRzUmVzcG9uc2UuUGxhdGZvcm1NZXRyaWNzLkltYWdlRGlzdHJpYnV0aW9uQ291bnRFbnRyeRJLChVjb21wdXRlX3VzYWdlX3NlY29uZHMYAyABKAsyLC5hcGkudjEuSW5zaWdodHNSZXNwb25zZS5QbGF0Zm9ybU1ldHJpY1N0YXRzElIKHGNvbXB1dGVfdXNhZ2Vfc2NhbGVkX3NlY29uZHMYBCABKAsyLC5hcGkudjEuSW5zaWdodHNSZXNwb25zZS5QbGF0Zm9ybU1ldHJpY1N0YXRzEkgKEnF1ZXVlX3RpbWVfc2Vjb25kcxgFIAEoCzIsLmFwaS52MS5JbnNpZ2h0c1Jlc3BvbnNlLlBsYXRmb3JtTWV0cmljU3RhdHMSRgoQcXVldWVfc2l6ZV9jb3VudBgGIAEoCzIsLmFwaS52MS5JbnNpZ2h0c1Jlc3BvbnNlLlBsYXRmb3JtTWV0cmljU3RhdHMaPQobSW1hZ2VEaXN0cmlidXRpb25Db3VudEVudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoAzoCOAEagQEKE1BsYXRmb3JtTWV0cmljU3RhdHMSCwoDbWluGAEgASgBEgsKA21heBgCIAEoARIMCgRtZWFuGAMgASgBEg4KBnN0ZGRldhgEIAEoARIWCg5zdW1fb2Zfc3F1YXJlcxgFIAEoARILCgNzdW0YBiABKAESDQoFY291bnQYByABKAEqMQoLR3JhbnVsYXJpdHkSDwoLVU5TUEVDSUZJRUQQABIICgRIT1VSEAESBwoDREFZEAIqhgEKCFBsYXRmb3JtEhQKEFBMQVRGT1JNX1VOS05PV04QABISCg5QTEFURk9STV9NQUNPUxABEhgKFFBMQVRGT1JNX0xJTlVYX0FSTTY0EAISGAoUUExBVEZPUk1fTElOVVhfQU1ENjQQAxIcChhQTEFURk9STV9MSU5VWF9BTUQ2NF9HUFUQBDKDAgoOQmFja2VuZFNlcnZpY2USVQoQTGlzdENhY2hlRW50cmllcxIfLmFwaS52MS5MaXN0Q2FjaGVFbnRyaWVzUmVxdWVzdBogLmFwaS52MS5MaXN0Q2FjaGVFbnRyaWVzUmVzcG9uc2USWwoSRGVsZXRlQ2FjaGVFbnRyaWVzEiEuYXBpLnYxLkRlbGV0ZUNhY2hlRW50cmllc1JlcXVlc3QaIi5hcGkudjEuRGVsZXRlQ2FjaGVFbnRyaWVzUmVzcG9uc2USPQoISW5zaWdodHMSFy5hcGkudjEuSW5zaWdodHNSZXF1ZXN0GhguYXBpLnYxLkluc2lnaHRzUmVzcG9uc2VCOVo3Z2l0aHViLmNvbS9jaXJydXNsYWJzL2NpcnJ1cy1ydW5uZXJzL2ludGVybmFsL2FwaS92MTt2MWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message api.v1.ListCacheEntriesRequest
 */
export type ListCacheEntriesRequest = Message<"api.v1.ListCacheEntriesRequest"> & {
  /**
   * @generated from field: string organization = 1;
   */
  organization: string;

  /**
   * @generated from field: string prefix = 2;
   */
  prefix: string;
};

/**
 * Describes the message api.v1.ListCacheEntriesRequest.
 * Use `create(ListCacheEntriesRequestSchema)` to create a new message.
 */
export const ListCacheEntriesRequestSchema: GenMessage<ListCacheEntriesRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 0);

/**
 * @generated from message api.v1.ListCacheEntriesResponse
 */
export type ListCacheEntriesResponse = Message<"api.v1.ListCacheEntriesResponse"> & {
  /**
   * @generated from field: repeated api.v1.CacheEntry entries = 1;
   */
  entries: CacheEntry[];
};

/**
 * Describes the message api.v1.ListCacheEntriesResponse.
 * Use `create(ListCacheEntriesResponseSchema)` to create a new message.
 */
export const ListCacheEntriesResponseSchema: GenMessage<ListCacheEntriesResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 1);

/**
 * @generated from message api.v1.CacheEntry
 */
export type CacheEntry = Message<"api.v1.CacheEntry"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: bool is_directory = 2;
   */
  isDirectory: boolean;

  /**
   * @generated from field: int64 size_bytes = 3;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp last_modified = 4;
   */
  lastModified?: Timestamp;
};

/**
 * Describes the message api.v1.CacheEntry.
 * Use `create(CacheEntrySchema)` to create a new message.
 */
export const CacheEntrySchema: GenMessage<CacheEntry> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 2);

/**
 * @generated from message api.v1.DeleteCacheEntriesRequest
 */
export type DeleteCacheEntriesRequest = Message<"api.v1.DeleteCacheEntriesRequest"> & {
  /**
   * @generated from field: string organization = 1;
   */
  organization: string;

  /**
   * @generated from field: repeated string keys = 2;
   */
  keys: string[];
};

/**
 * Describes the message api.v1.DeleteCacheEntriesRequest.
 * Use `create(DeleteCacheEntriesRequestSchema)` to create a new message.
 */
export const DeleteCacheEntriesRequestSchema: GenMessage<DeleteCacheEntriesRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 3);

/**
 * Empty for now
 *
 * @generated from message api.v1.DeleteCacheEntriesResponse
 */
export type DeleteCacheEntriesResponse = Message<"api.v1.DeleteCacheEntriesResponse"> & {
};

/**
 * Describes the message api.v1.DeleteCacheEntriesResponse.
 * Use `create(DeleteCacheEntriesResponseSchema)` to create a new message.
 */
export const DeleteCacheEntriesResponseSchema: GenMessage<DeleteCacheEntriesResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 4);

/**
 * @generated from message api.v1.InsightsRequest
 */
export type InsightsRequest = Message<"api.v1.InsightsRequest"> & {
  /**
   * @generated from field: string organization = 1;
   */
  organization: string;

  /**
   * @generated from field: api.v1.Granularity granularity = 2;
   */
  granularity: Granularity;
};

/**
 * Describes the message api.v1.InsightsRequest.
 * Use `create(InsightsRequestSchema)` to create a new message.
 */
export const InsightsRequestSchema: GenMessage<InsightsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 5);

/**
 * @generated from message api.v1.InsightsResponse
 */
export type InsightsResponse = Message<"api.v1.InsightsResponse"> & {
  /**
   * @generated from field: int64 runners_count = 1;
   */
  runnersCount: bigint;

  /**
   * @generated from field: repeated api.v1.InsightsResponse.Aggregate aggregates = 2;
   */
  aggregates: InsightsResponse_Aggregate[];
};

/**
 * Describes the message api.v1.InsightsResponse.
 * Use `create(InsightsResponseSchema)` to create a new message.
 */
export const InsightsResponseSchema: GenMessage<InsightsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 6);

/**
 * @generated from message api.v1.InsightsResponse.Aggregate
 */
export type InsightsResponse_Aggregate = Message<"api.v1.InsightsResponse.Aggregate"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_at = 1;
   */
  startAt?: Timestamp;

  /**
   * @generated from field: repeated api.v1.InsightsResponse.PlatformMetrics platform_metrics = 2;
   */
  platformMetrics: InsightsResponse_PlatformMetrics[];
};

/**
 * Describes the message api.v1.InsightsResponse.Aggregate.
 * Use `create(InsightsResponse_AggregateSchema)` to create a new message.
 */
export const InsightsResponse_AggregateSchema: GenMessage<InsightsResponse_Aggregate> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 6, 0);

/**
 * @generated from message api.v1.InsightsResponse.PlatformMetrics
 */
export type InsightsResponse_PlatformMetrics = Message<"api.v1.InsightsResponse.PlatformMetrics"> & {
  /**
   * @generated from field: api.v1.Platform platform = 1;
   */
  platform: Platform;

  /**
   * @generated from field: map<string, int64> image_distribution_count = 2;
   */
  imageDistributionCount: { [key: string]: bigint };

  /**
   * @generated from field: api.v1.InsightsResponse.PlatformMetricStats compute_usage_seconds = 3;
   */
  computeUsageSeconds?: InsightsResponse_PlatformMetricStats;

  /**
   * @generated from field: api.v1.InsightsResponse.PlatformMetricStats compute_usage_scaled_seconds = 4;
   */
  computeUsageScaledSeconds?: InsightsResponse_PlatformMetricStats;

  /**
   * @generated from field: api.v1.InsightsResponse.PlatformMetricStats queue_time_seconds = 5;
   */
  queueTimeSeconds?: InsightsResponse_PlatformMetricStats;

  /**
   * @generated from field: api.v1.InsightsResponse.PlatformMetricStats queue_size_count = 6;
   */
  queueSizeCount?: InsightsResponse_PlatformMetricStats;
};

/**
 * Describes the message api.v1.InsightsResponse.PlatformMetrics.
 * Use `create(InsightsResponse_PlatformMetricsSchema)` to create a new message.
 */
export const InsightsResponse_PlatformMetricsSchema: GenMessage<InsightsResponse_PlatformMetrics> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 6, 1);

/**
 * @generated from message api.v1.InsightsResponse.PlatformMetricStats
 */
export type InsightsResponse_PlatformMetricStats = Message<"api.v1.InsightsResponse.PlatformMetricStats"> & {
  /**
   * @generated from field: double min = 1;
   */
  min: number;

  /**
   * @generated from field: double max = 2;
   */
  max: number;

  /**
   * @generated from field: double mean = 3;
   */
  mean: number;

  /**
   * @generated from field: double stddev = 4;
   */
  stddev: number;

  /**
   * @generated from field: double sum_of_squares = 5;
   */
  sumOfSquares: number;

  /**
   * @generated from field: double sum = 6;
   */
  sum: number;

  /**
   * @generated from field: double count = 7;
   */
  count: number;
};

/**
 * Describes the message api.v1.InsightsResponse.PlatformMetricStats.
 * Use `create(InsightsResponse_PlatformMetricStatsSchema)` to create a new message.
 */
export const InsightsResponse_PlatformMetricStatsSchema: GenMessage<InsightsResponse_PlatformMetricStats> = /*@__PURE__*/
  messageDesc(file_api_v1_api, 6, 2);

/**
 * @generated from enum api.v1.Granularity
 */
export enum Granularity {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: HOUR = 1;
   */
  HOUR = 1,

  /**
   * @generated from enum value: DAY = 2;
   */
  DAY = 2,
}

/**
 * Describes the enum api.v1.Granularity.
 */
export const GranularitySchema: GenEnum<Granularity> = /*@__PURE__*/
  enumDesc(file_api_v1_api, 0);

/**
 * @generated from enum api.v1.Platform
 */
export enum Platform {
  /**
   * @generated from enum value: PLATFORM_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: PLATFORM_MACOS = 1;
   */
  MACOS = 1,

  /**
   * @generated from enum value: PLATFORM_LINUX_ARM64 = 2;
   */
  LINUX_ARM64 = 2,

  /**
   * @generated from enum value: PLATFORM_LINUX_AMD64 = 3;
   */
  LINUX_AMD64 = 3,

  /**
   * @generated from enum value: PLATFORM_LINUX_AMD64_GPU = 4;
   */
  LINUX_AMD64_GPU = 4,
}

/**
 * Describes the enum api.v1.Platform.
 */
export const PlatformSchema: GenEnum<Platform> = /*@__PURE__*/
  enumDesc(file_api_v1_api, 1);

/**
 * @generated from service api.v1.BackendService
 */
export const BackendService: GenService<{
  /**
   * @generated from rpc api.v1.BackendService.ListCacheEntries
   */
  listCacheEntries: {
    methodKind: "unary";
    input: typeof ListCacheEntriesRequestSchema;
    output: typeof ListCacheEntriesResponseSchema;
  },
  /**
   * @generated from rpc api.v1.BackendService.DeleteCacheEntries
   */
  deleteCacheEntries: {
    methodKind: "unary";
    input: typeof DeleteCacheEntriesRequestSchema;
    output: typeof DeleteCacheEntriesResponseSchema;
  },
  /**
   * @generated from rpc api.v1.BackendService.Insights
   */
  insights: {
    methodKind: "unary";
    input: typeof InsightsRequestSchema;
    output: typeof InsightsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_api, 0);

